import axios from "axios";
import { API } from "./api";

const CHUNK = 4 * 1024 * 1024;

// Upload a file in small pieces so large videos get past proxy limits. Returns the file URL.
export async function uploadChunked(file, headers, onProgress) {
  const uploadId = Math.random().toString(36).slice(2) + Date.now().toString(36);
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  let url = null;
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("index", i);
    fd.append("total", total);
    fd.append("filename", file.name);
    fd.append("file", file.slice(i * CHUNK, (i + 1) * CHUNK), file.name);
    const { data } = await axios.post(`${API}/admin/uploads/chunk`, fd, { headers });
    onProgress?.(Math.round(((i + 1) / total) * 100));
    if (data.done) url = data.url;
  }
  return url;
}
